module.exports = __webpack_public_path__ + "media/images/games/35gender/boy-doll-104ae957b9e9b8737f3e10bf9a53e2c3.png";